import type { BucketIcon, IconColor } from "~/types/icon";
import { motion } from "framer-motion"
import { cn } from "~/lib/utils";
import { ItemStyle } from "../_config";
import Icon from "~/components/icons";
import { usePlan } from "../plan.context";


interface ItemProps {
  icon: BucketIcon;
  title: string;
  caption: string;
}

export default function Item({ icon, title, caption }: ItemProps) {
  const { color } = usePlan()

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 300 }}
      className="z-20 h-full"
    >
      <div className={cn("cursor-default h-full bg-gray-950 card card-body rounded-2xl border p-5 shadow-lg transition", ItemStyle[color])}>
        <div className="mb-2 flex items-center gap-3">
          <Icon icon={icon} color={color as IconColor} />
          <h3 className="font-bold text-white">{title}</h3>
        </div>
        <p className="text-sm text-gray-400">{caption}</p>
      </div>
    </motion.div>
  );
}
